module.exports = __webpack_public_path__ + "img/standard.af385af4.png";